"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const rolesQuery_1 = require("../../../../queries/rolesQuery");
const teamQuery_1 = require("../../../../queries/teamQuery");
const userQuery_1 = require("../../../../queries/userQuery");
const zustandStore_1 = require("../../../../zustandStore");
const codingList_1 = __importDefault(require("../../../organisms/createTeamModal/codingList"));
const TeamSettingsCodingTemplate = () => {
    const teamId = (0, zustandStore_1.useZustand)(state => state?.team?.teamId || '');
    const { data: userData } = (0, userQuery_1.useGetUserQuery)();
    const { data: userSelectedTeamData } = (0, react_query_1.useQuery)((0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'));
    const { setUser, setCompanyName, setCompanyId, setUserSelectedTeam } = (0, zustandStore_1.useZustand)();
    const { data: role } = (0, rolesQuery_1.useGetRoleForUserQuery)(userData, teamId);
    (0, react_1.useEffect)(() => {
        setUserSelectedTeam(userSelectedTeamData?.[0] || '');
    }, [userSelectedTeamData, setUserSelectedTeam]);
    (0, react_1.useEffect)(() => {
        if (userData) {
            setUser(userData);
            setCompanyName(userData.companyName);
            setCompanyId(userData.companyAccountId);
        }
    }, [setCompanyId, setCompanyName, setUser, userData]);
    return ((0, jsx_runtime_1.jsx)(material_1.Paper, { "ts-variant": "container", children: (0, jsx_runtime_1.jsx)(codingList_1.default, { roleId: role?.id || userData?.roles?.[0]?.roleId || '' }) }));
};
exports.default = TeamSettingsCodingTemplate;
